module.exports = __webpack_public_path__ + "static/media/KL.527b8236.png";